import React, { useCallback, useEffect, useState, forwardRef } from 'react';
import Grid from '@mui/joy/Grid';
import Box from '@mui/joy/Box';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Autocomplete from '@mui/joy/Autocomplete';
import Typography from '@mui/joy/Typography';
import { styled } from '@mui/joy/styles';
import Sheet from '@mui/joy/Sheet';
import Input from '@mui/joy/Input';


import Button from '@mui/joy/Button';
import AddIcon from '../../../assets/icons/Add-icon.svg'


/////////////////// Modal
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import DialogTitle from '@mui/joy/DialogTitle';
import Stack from '@mui/joy/Stack';
import Textarea from '@mui/joy/Textarea';


////////////// Switch Button
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';



//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

///////////////// Use Form
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';




//////////////////////// API
import { createNewBrand, getBrands, getBrandsInRegisterModel } from '../../../Api/Brands';

const schema = yup.object({
    // image: yup.mixed().required("يرجى رفع صورة القسم"),
    title_ar: yup.string().required("هذا الحقل مطلوب"),
    title_en: yup.string().required("هذا الحقل مطلوب"),

})


const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const VisuallyHiddenInput = styled('input')`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
`;

export default function StepOne({getDataFromStepOne, dataObjBrandId, getDataManual, dataManual}) {
    const [totalNumberModel, setTotalNumberModel] = useState([])
    const [listBrands, setListBrands] = useState([])
    const [brandCurrentValue, setBrandCurrentValue] = useState(null)
    const [open, setOpen] = useState(false);
    const [urlImageName, setUrlImageName] = useState("قم برفع شعار الماركة")
    const [imageDataTwo, setImageDataTwo] = useState(null)
    const [loading, setLoading] = useState(false)
    const [openAlert, setOpenAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');

    const [openAlertError, setOpenAlertError] = useState(false);
    const [messageAlertError, setMessageAlertError] = useState('');

    const [checked, setChecked] = useState(false);

    const form = useForm({
        defaultValues: {
            // image: '',
            title_ar: "",
            title_en: "",
        },
        resolver: yupResolver(schema)
    });
    const { register, handleSubmit, formState, setValue } = form;
    const { errors } = formState


    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleCloseAlertError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlertError(false);
    };
    const openNewModel = () => {
        setOpen(true)
        // setTotalNumberModel([...totalNumberModel, totalNumberModel.length + 1])
    }

    const handlSelectBrand = (e, selectBrand) => {
        if (selectBrand) {
            getDataFromStepOne(selectBrand);
        }
        
    };

    const switchToggle = (event) => {
        // console.log("switchToggle ", event.target.checked)
        setChecked(event.target.checked);
        getDataManual(event.target.checked)
    }

    const getCurrentValueBrand = () => {
       let getValue = listBrands.find((brand) => brand.id == dataObjBrandId)
       setBrandCurrentValue(getValue)
    }
    

    const getCurrentValueManual = () => {
        // let getValue = listBrands.find((brand) => brand.id == dataObjBrandId)
        setChecked(dataManual == 1 ? true : false)
     }

    const imgNews = (event) => {
        let image = event.target;
        if (image.files && image.files[0]) {
            setImageDataTwo(image.files[0]);
            console.log(image.files[0])
            setUrlImageName(image.files[0].name)
            var reader = new FileReader();
            // reader.onload = (e) => {
            //     setUrlImage(e.target.result);
            // }
            reader.readAsDataURL(image.files[0]);
        }
    };

    const sendNewBrand = async (data) => {
        setLoading(true)
        if (data.image) {
            data.image = data.image[0]
        }

        try {
            const res = await createNewBrand(data)
            if (res) {
                setLoading(false)
                setOpen(false)
                getListBrands()
                setOpenAlert(true)
                setMessageAlert('تم اضافة قسم بنجاح')
                setValue('image', '')
                setValue('title_ar', '')
                setValue('title_en', '')
                setImageDataTwo(null)
                setUrlImageName("قم برفع صورة الماركة")
            }

        } catch (error) {
            if (error.response) {
                setLoading(false)
                setOpen(false)
                setOpenAlertError(true)
                setMessageAlertError(error.response.data.message)
            }
        }
    };

    const getListBrands = useCallback(async () => {
        const res = await getBrandsInRegisterModel();
        setListBrands(res)
    }, []);



    useEffect(() => {
        getListBrands();
    }, [getListBrands]);

    useEffect(() => {
        getCurrentValueBrand();
    }, [getCurrentValueBrand]);


    useEffect(() => {
        getCurrentValueManual();
    }, [getCurrentValueManual]);
    


    return (
        <>
            {/* Alert Message */}
            <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
                <Alert severity="success">{messageAlert}</Alert>
            </Snackbar>

            <Snackbar open={openAlertError} autoHideDuration={6000} onClose={handleCloseAlertError}>
                <Alert onClose={handleCloseAlertError} severity="warning" sx={{ width: '100%' }}>
                    {messageAlertError}
                </Alert>
            </Snackbar>

            {/* Modal Create New */}
            <Modal
                aria-labelledby="modal-title"
                aria-describedby="modal-desc"
                open={open}
                onClose={() => setOpen(false)}
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', overflowY: 'scroll' }}
            >
                <Sheet
                    variant="outlined"
                    sx={{
                        Width: 500,
                        borderRadius: 'md',
                        p: 3,
                        boxShadow: 'lg',
                        position: 'relative',
                    }}
                >
                    <DialogTitle sx={{ fontSize: '20px', color: '#434448', fontWeight: 'bold', direction:'rtl' }}>إضافة ماركة جديدة</DialogTitle>
                    {/* <ModalClose variant="plain" sx={{ m: 1, position: 'absolute', left: '0' }} /> */}
                    <Box sx={{ width: '500px', paddingTop: '30px', direction:'rtl' }}>
                        <form
                            onSubmit={handleSubmit(sendNewBrand)}
                        >
                            <Stack spacing={2}>
                                <FormControl>
                                    <FormLabel sx={{fontSize:'16px', color:'#434448'}}>الماركة باللغة العربية</FormLabel>
                                    <Input
                                        sx={{
                                            height: '60px',
                                            borderRadius: '30px'
                                        }}
                                        autoFocus
                                        placeholder='ادخل الماركة باللغة العربية' 
                                        {...register('title_ar')}
                                    />
                                    {errors.title_ar &&
                                        <Typography
                                            color="danger"
                                            level="body-xs"
                                            variant="plain"
                                        >{errors.title_ar?.message}</Typography>
                                    }
                                </FormControl>
                                <FormControl sx={{ direction: 'ltr' }}>
                                    <FormLabel sx={{fontSize:'16px', color:'#434448'}}>Brand Name</FormLabel>
                                    <Input
                                        sx={{
                                            height: '60px',
                                            borderRadius: '30px'
                                        }}
                                        autoFocus
                                        placeholder='Brand Name .....'
                                        {...register('title_en')}
                                    />
                                    {errors.title_en &&
                                        <Typography
                                            color="danger"
                                            level="body-xs"
                                            variant="plain"
                                        >{errors.title_en?.message}</Typography>
                                    }
                                </FormControl>

                                {/* <FormControl>
                                    <FormLabel sx={{fontSize:'16px', color:'#434448'}}>الشعار</FormLabel>
                                    <Button
                                        component="label"
                                        role={undefined}
                                        tabIndex={-1}
                                        variant="outlined"
                                        color="neutral"
                                        sx={{ border: '1px solid #E6E6E6', padding: '0', position: 'relative', height: '60px', paddingLeft: '40%', borderRadius: '30px' }}
                                        endDecorator={
                                            <Box sx={{ backgroundColor: '#3E64F4', color: '#FFF', position: 'absolute', left: '0', top: '0', width: '30%', height: '60px', textAlign: 'center', lineHeight: '60px', borderRadius: '30px' }}>
                                                Upload
                                            </Box>
                                        }
                                    >
                                        {urlImageName}
                                        <VisuallyHiddenInput type="file" {...register('image')} onChange={(e) => imgNews(e)}/>
                                    </Button>
                                    {errors.image &&
                                        <Typography
                                            color="danger"
                                            level="body-xs"
                                            variant="plain"
                                        >{errors.image?.message}</Typography>
                                    }
                                </FormControl> */}

                                <Box sx={{ display: 'flex', width: '100%', justifyContent: 'flex-end', paddingTop: '40px' }}>
                                    <Button type="submit" loading={loading} sx={{ borderRadius: '15px', backgroundColor: '#3E64F4', height: '60px', width: '170px', marginLeft: '20px' }}>اضافة الماركة</Button>
                                    <Button type="button" onClick={() => setOpen(false)} sx={{ borderRadius: '15px', backgroundColor: '#757778', height: '60px', width: '170px' }}>الغاء</Button>
                                </Box>
                            </Stack>
                        </form>
                    </Box>
                </Sheet>
            </Modal>



            <Grid
                container
                direction='row'
                spacing={3}
            >
                <Grid xs={12}>
                    <Box component="section" sx={{ display: 'flex', width: '100%', gap: '20px' }}>
                        {/* <FormControl sx={{ width: '30%' }}>
                        <FormLabel sx={{ fontSize: '16px', color: '#434448' }}>الماركة</FormLabel>
                        <Autocomplete
                            placeholder="مثال : تويوتا"
                            options={listBrands}
                            sx={{ width: '100%', height: '45px' }}
                        />
                    </FormControl> */}

                        <FormControl sx={{ width: '30%' }}>
                            {/* {dataObjBrandId} */}
                            {/* <FormLabel sx={{ fontSize: '16px', color: '#434448' }}>الماركة باللغة الانجليزية</FormLabel> */}
                            <FormLabel sx={{ fontSize: '16px', color: '#434448' }}>الماركة</FormLabel>
                            <Autocomplete
                                placeholder="الماركة"
                                options={listBrands}
                                value={brandCurrentValue}
                                getOptionLabel={listBrands => listBrands.title_en + ' - ' + listBrands.title_ar}
                                onChange={handlSelectBrand}
                                sx={{ width: '100%', height: '45px' }}
                            />
                        </FormControl>
                    </Box>

                    <FormGroup>
                        <FormControlLabel control={<Switch checked={checked}  onChange={switchToggle}/>} label="تقيم ذاتى" />
                    </FormGroup>
                </Grid>

                <Grid xs={12} sx={{ marginTop: '50px' }}>
                    <Typography level="h3" fontSize="xl" sx={{ fontSize: '16px', color: '#434448', marginBottom: '30px' }}>
                        لم تجد الماركة التي تريدها؟
                    </Typography>
                    <Button size="md" onClick={openNewModel} variant='solid' color="primary" startDecorator={<img className='imgIconButton' src={AddIcon} alt='icon' />}>
                        إضافة ماركة جديدة
                    </Button>
                </Grid>
            </Grid>
        </>

    );
}